import { axiosInstance } from '../../../api/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Member/api/APIEndpoints';

export const getEnrollmentClientConfigurations = createAsyncThunk(
  'getEnrollmentClientConfigurations',
  async () => {
    const apiUrl = APIEndpoints.getEnrollClientConfig();
    const response = await axiosInstance.get(apiUrl);
    return response;
  },
);
